import { axiosRequest } from '@/util/axios-request';

// 二维码扫码状态查询
export var commonDeptList = function commonDeptList(data) {
  return axiosRequest({
    url: '/web/Organization/commonDeptList',
    method: 'GET',
    params: data
  });
};

// 审批流—获取条件配置列表
export var getConditionList = function getConditionList(data) {
  return axiosRequest({
    url: '/web/workflow/getConditionList',
    method: 'GET',
    params: data
  });
};

// 审批流—筛选项
export var selectApi = function selectApi(data) {
  return axiosRequest({
    url: 'web/workflow/init',
    method: 'GET'
  });
};

// 审批流—列表
export var lists = function lists(data) {
  return axiosRequest({
    url: '/web/workflow/lists',
    method: 'GET',
    params: data
  });
};

// 获取审批流
export var getWorkFlow = function getWorkFlow(data) {
  return axiosRequest({
    url: '/web/workflow/get',
    method: 'GET',
    params: data
  });
};

// 保存审批配置
export var workFlowSave = function workFlowSave(data) {
  return axiosRequest({
    url: '/web/workflow/save',
    data: data
  });
};

// 审批流—更新
export var workUpdateSave = function workUpdateSave(data) {
  return axiosRequest({
    url: '/web/workflow/update',
    data: data
  });
};

// 审批流—启停操作
export var switchStatus = function switchStatus(data) {
  return axiosRequest({
    url: '/web/workflow/switchStatus',
    data: data
  });
};

// 审批人抄送人选项
export var getWorkflowNoteInfo = function getWorkflowNoteInfo(params) {
  return axiosRequest({
    url: '/web/Workflow/getWorkflowNoteConfig',
    params: params,
    method: 'GET'
  });
};

// 获取币种
export var getCurrency = function getCurrency(data) {
  return axiosRequest({
    url: '/web/workflow/getCurrency',
    data: data
  });
};
export var getWorkFlowList = function getWorkFlowList(data) {
  return axiosRequest({
    url: '/web/workflow/workFlowList',
    data: data
  });
};
export var insertOrUpdateGroup = function insertOrUpdateGroup(data) {
  return axiosRequest({
    url: '/web/workflow/insertOrUpdateGroup',
    data: data
  });
};
export var delGroup = function delGroup(data) {
  return axiosRequest({
    url: '/web/workflow/delGroup',
    data: data
  });
};
export var getGroup = function getGroup(data) {
  return axiosRequest({
    url: '/web/workflow/getGroup',
    data: data
  });
};
export var getLanguage = function getLanguage(data) {
  return axiosRequest({
    url: '/web/workflow/getLanguage',
    data: data
  });
};
export var saveLanguage = function saveLanguage(data) {
  return axiosRequest({
    url: '/web/workflow/saveLanguage',
    data: data
  });
};
export var getFlowTypes = function getFlowTypes(data) {
  return axiosRequest({
    url: '/web/workflow/getFlowTypes',
    data: data
  });
};